// Windows Ready Handler
(function($) {

    $(document).ready(function(){
        $(".wp-block-navigation-item.has-child").on("click", (e) => {
            console.log("Clicked!");
            let item = e.target;
            let link = $(item).closest(".has-child").children("a");
            link.toggleClass("open");
            let list = $(link).siblings("ul");
            $(list).slideToggle();
        })
    });

}(jQuery));
